
export function getDeliveryDateString (parts) {
  const deliveryDateNumbers = []
  let deliveryDateLabel = ''
  let maxDeliveryDatesNumber = 0

  parts.map(element => {
    deliveryDateNumbers.push(element.deliveryDate)
  })

  // 空判定用総和
  const sum = deliveryDateNumbers.reduce((prev, current) => {
    return (prev + current)
  })

  if (sum < 0) {
    deliveryDateLabel = '即日'
  } else if (sum === 0) { // 全ての数値が0の場合は表示しない
    deliveryDateLabel = ''
  } else {
    maxDeliveryDatesNumber = Math.max.apply(null, deliveryDateNumbers)
    deliveryDateLabel = '約' + String(maxDeliveryDatesNumber) + '週間後'
  }

  return deliveryDateLabel
}



// WEBPACK FOOTER //
// ./src/modules/utilityFunctions.js